import { createSelector } from '@reduxjs/toolkit';

import { selectConnectedLeafNodeIds } from './selectConnectedLeafNodeIds';
import { selectLabwareIdsForTaskByTaskId } from './selectLabwareIdsForTaskByTaskId';

/** A mapping of {labwareId: finalTaskId} for all connected labware */
export const selectFinalTasksByLabwareId = createSelector(
  selectLabwareIdsForTaskByTaskId,
  selectConnectedLeafNodeIds,
  (labwareIdsForTaskByTaskId, leafNodeIds): { [labwareId: string]: string } => {
    const finalTasksByLabwareId: { [labwareId: string]: string } = {};

    for (const taskId of leafNodeIds) {
      for (const labwareId of Object.values(
        labwareIdsForTaskByTaskId[taskId] ?? {}
      )) {
        if (labwareId !== null) {
          finalTasksByLabwareId[labwareId] = taskId;
        }
      }
    }
    return finalTasksByLabwareId;
  }
);
